<div mat-dialog-title>
  <ng-container *ngIf="title">
    <ng-container i18n="@@dialogHeader.title">{title, select,
      other {{{ title }}}
    }</ng-container>
  </ng-container>
  <div *ngIf="subtitle" class="text-subtitle-1">
    <ng-container i18n="@@dialogHeader.subtitle">{subtitle, select,
      other {{{ subtitle }}}
    }</ng-container>
  </div>
</div>
